import axios from 'axios';

// Maestro de clientes (propuesta integral Fase 1, doc 08 A.3).
export default {
  search(params) {
    return axios.get('/customers', { params });
  },

  get(id) {
    return axios.get(`/customers/${id}`);
  },

  update(id, data) {
    return axios.put(`/customers/${id}`, data);
  },

  lookup(params) {
    return axios.get('/customers/lookup', { params });
  },

  qr(id) {
    return axios.get(`/customers/${id}/qr`);
  }
}
